import { ChangesSection } from '@/components/home/ChangesSection'
import { HomeHero } from '@/components/home/HomeHero'
import { PropositionSection } from '@/components/home/PropositionSection'
import { ShiftSection } from '@/components/home/ShiftSection'
import { TeamSection } from '@/components/home/TeamSection'
import { VoicesSection } from '@/components/home/VoicesSection'
import { useSectionPaging } from '@/components/motion/useSectionPaging'
import { InviteSection } from '@/components/sections/InviteSection'
import { PageSeo } from '@/components/seo/PageSeo'
import { sitePages } from '@/config/pages'

/** The sections that each take a screen with magnetic scroll. */
const homeScreens = '.x-shift, .x-voices, .x-prop, .x-chapter, .x-team, .x-invite'

export const HomePage = () => {
  useSectionPaging(homeScreens)

  return (
    <>
      <PageSeo page={sitePages.home} />
      <HomeHero />
      <ShiftSection />
      <VoicesSection />
      <PropositionSection />
      <ChangesSection />
      <TeamSection />
      <InviteSection
        id="contact"
        titleId="cta-title"
        eyebrow="An invitation"
        title="Start with a conversation about your firm"
        lead="Tell us about your firm and what you want it to become. We’ll see together whether there’s a fit."
      />
    </>
  )
}
